module.exports = __webpack_public_path__ + "img/Camera-Icon-01.0e335627.svg";